import { createGlobalStyle } from 'styled-components';

export const AppGlobalStyle = createGlobalStyle`
  /*
    RESET CSS
  */
  
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
      margin: 0;
      padding: 0;
      border: 0;
      font-size: 100%;
      font: inherit;
      vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
      display: block;
  }
  body {
      line-height: 1;
  }
  ol, ul {
      list-style: none;
  }
  blockquote, q {
      quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
      content: '';
      content: none;
  }
  table {
      border-collapse: collapse;
      border-spacing: 0;
  }
  
  /*
    General app-wide styles
  */
  * {
      font-family: 'Montserrat', sans-serif;
      font-size: 14px;
      /*box-sizing: border-box;*/
  }
  
  #root {
      height: 100vh;
  }
  
  
  
  
  button {
      background-color: transparent;
      border: none;
      outline: none;
      margin: 0;
  }
  
  .noselect {
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
  }
  
  .withOverflow {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  
  }


  body {
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      padding-right: 10px;
            background-color: ${(props) => (props.theme as any).scrollbarBackgroundColor};

    }
    
    &::-webkit-scrollbar-thumb {
      background-color: ${(props) => (props.theme as any).scrollbarThumbBackgroundColor};
       border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
      background-color: ${(props) => (props.theme as any).scrollbarThumbBackgroundColorHover};
    }
  } 
`;
